import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Icon } from '@iconify/react/dist/iconify.js'
import './style.css'

const BackBtn = ({ to, title, className="" }) => {
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()

  const handleBack = () => {
    if (to) {
      navigate(to)
    } else {
      navigate(-1)
    }
  }

  return (
    <button
      onClick={handleBack}
      className={`back-btn ${className}`}
    >
        <Icon icon={i18n.language !== 'ar' ? "material-symbols:arrow-back-rounded" : "material-symbols:arrow-forward-rounded"} width={24} height={24} />
        <span>{title ? title : t('back')}</span>
    </button>
  )
}

export default BackBtn